import config from 'src/config/app'

import { BannerContainer, Text, LinkPromotion } from './styles'

const PromotionBanner = () => {
  const wsp_endpoint = `https://api.whatsapp.com`
  const cellNumber = config.web.cellNumber?.replace(/([\+\ \&])/g, '')
  const message = 'Hola, me gustaría solicitar una cotización rápida.'
  return (
    <BannerContainer>
      <Text>¿Tienes RUC 20? Obtén crédito para la compra de tus materiales...</Text>
      <LinkPromotion href={`${wsp_endpoint}/send?phone=${cellNumber}&text=${message}`}>
        ¡Cotiza aquí!
      </LinkPromotion>
    </BannerContainer>
  )
}

export default PromotionBanner
